export default __webpack_public_path__ + "static/media/TL01.2.43a8b777.mp3";